import React, { useContext, useEffect, useState } from 'react'
import IntervenerCard from './IntervenerCard'
import IntervenerPage from './IntervenerPage'
import { useParams } from 'react-router'
import { get } from '../../Common/api'
import GlobalContext from '../GlobalContext'

export default function Intervener () {
  const { id } = useParams()
  const [intervener, setIntervener] = useState()
  const [loading, setLoading] = useState(false)
  const { screens } = useContext(GlobalContext)

  useEffect(() => {
    setLoading(true)
    getIntervener()
    setLoading(false)
  }, [])

  const getIntervener = async () => {
    await get({
      url: `admin/interveners/${id}`,
      params: {},
      onSuccess: (json) => {
        setIntervener({ ...json, phones: (json.phones.map(phone => ({ ...phone, value: `+${phone.value}` }))) })
      }
    })
  }

  return (
    <>
      {screens.xs && intervener && <IntervenerCard intervener={intervener} loading={loading} setLoading={setLoading} setIntervener={setIntervener} />}
      {!screens.xs && intervener && <IntervenerPage intervener={intervener} loading={loading} setLoading={setLoading} setIntervener={setIntervener} />}
    </>
  )
}
